<template>
  <q-dialog
    v-model="shown"
    :persistent="deliveryPositions && !!deliveryPositions.length"
  >
    <q-card style="min-width: 60vw;">
      <q-card-section>
        <slot name="title" />
        <div>
          <q-btn
            v-for="position in deliveryPositions"
            :key="position"
            class="row full-width q-my-md"
            size="lg"
            color="primary"
            clickable
            no-caps

            @click="$emit('select-position', orderItem, position)"
          >
            {{ position }}
            <q-badge
              v-if="position === owner"
              class="q-py-xs absolute-top-right"
              style="margin-top: -8px; margin-right: 4px;"
              align="middle"
              color="positive"
              multi-line
              :text-color="$getColor(currentSite, 'positive')"
            >
              {{ ownerLabel() }}
            </q-badge>
          </q-btn>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'DeliveryPositionDialog',
  emits: ['select-position'],
  data () {
    return {
      shown: false,
      orderItem: null,
      deliveryPositions: [],
      owner: null
    }
  },
  configuration: ['currentSite'],
  watch: {
    shown (shown) {
      if (!shown) {
        this.orderItem = null
      }
    }
  },
  methods: {
    show (deliveryPositions, orderItem, owner) {
      this.deliveryPositions = _.sortBy(deliveryPositions)
      this.orderItem = orderItem
      this.owner = owner
      this.shown = true
    },
    hide () {
      this.shown = false
    },
    ownerLabel () {
      return this.$register ? this.$t('common.owner') : this.$t('checkout.delivery.yourSeat')
    }
  }
}

</script>
